export default "__VITE_ASSET__oHXc98Pf__"